import {SegmentInt} from "@interfaces/*";
import { PNRLookupAWSInt, PassengerAWSInt } from '@app/interfaces/reservation-aws.interface';
import { Reservation } from '@app/models/micro/reservation.model';


export class RequestMicroModel {
  reservationCode: string
  tripType: string
  passengerNumbers: string
  typeReservation: string =  'PAID'
  lastName: string
  isEmployee: boolean = false
  isStandBy: boolean = false
  remarks: any[]
  bookedLegCollection: LegModelRQ[]
  passengers: PassengerModelRQ[]

  constructor(reservation: PNRLookupAWSInt, lookup: Reservation) {
    this.reservationCode  = reservation.reservationCode
    this.tripType = reservation.tripType
    this.passengerNumbers = reservation.passengerNumbers
    const { passengers: lookupPassengers } = lookup

    const current =  reservation.bookedLegCollection.find(el=> el.legCode === lookup.flightSummary.legCode)
    this.bookedLegCollection = [new LegModelRQ(current)]
    const passengerNoStb =  reservation.passengers.filter(p => !p.isStandBy)
    this.passengers = passengerNoStb
      .filter(p => lookupPassengers.find(el => el.nameRefNumber === p.passengerNameNumber && !el.onPriorityCodeListOVS))
      .map(passenger => new PassengerModelRQ( passenger,lookup.flightSummary.segmentCode));
    const [fistPassenger] = passengerNoStb
    this.lastName = fistPassenger?.passengerDetails.lastName;
    this.remarks = []
  }
}

export class LegModelRQ {
  legCode: string
  legEntity: string = 'DOM'
  legRegion: string
  remainingTimeToDeparture: number
  remainingTimeToDocuments: number
  remainingTimeToCheckin: number
  totalFlightDuration: number
  windowLegStatus: string
  segments: SegmentRQ[]

  constructor(leg) {
    this.legCode = leg.legCode
    this.legEntity = leg.legEntity
    this.legRegion = leg.legRegion
    this.remainingTimeToCheckin = leg.remainingTimeToCheckin
    this.remainingTimeToDeparture = leg.remainingTimeToDeparture
    this.remainingTimeToDocuments = leg.remainingTimeToDocuments
    this.totalFlightDuration = leg.totalFlightDuration
    this.windowLegStatus = leg.windowLegStatus
    this.segments = leg.segments.map( (segment: SegmentInt )  => new SegmentRQ(segment));
  }
}


export class SegmentRQ {
  id: string
  fareFamily: string
  segmentCode: string
  segmentEntity: string
  segmentRegion: string
  departureAirport: string
  departureTerminal: string
  departureDateTime: string
  arrivalAirport: string
  arrivalTerminal: string
  arrivalDateTime: string
  marketingCarrier: string
  marketingFlightCode: string
  operatingCarrier: string
  operatingFlightCode: string
  segmentStatusCode: string
  segmentStatus: string
  cabinClass: string
  bookingClass: string
  farebasis: string
  aircraftType: string
  flightDuration: number
  layoverDuration: number
  sequence :number
  onUpgradeList :boolean
  departureAirportTimeZoneId :string
  arrivalAirportTimeZoneId :string
  hiddenStop :any
  arrivalAirportRegion :string
  departureAirportRegion :string
  remainingSegmentTimeToCheckin :number
  windowSegmentStatus :string
  departureCountry:string
  arrivalCountry:string
  constructor(segment) {
    this.id = segment?.id
    this.fareFamily = segment?.fareFamily
    this.segmentCode = segment?.segmentCode
    this.segmentEntity = segment?.segmentEntity
    this.segmentRegion = segment?.segmentRegion
    this.departureAirport = segment?.departureAirport
    this.departureTerminal = segment?.departureTerminal
    this.departureDateTime = segment?.departureDateTime
    this.arrivalAirport = segment?.arrivalAirport
    this.arrivalTerminal = segment?.arrivalTerminal
    this.arrivalDateTime = segment?.arrivalDateTime
    this.marketingCarrier = segment?.marketingCarrier
    this.marketingFlightCode = segment?.marketingFlightCode
    this.operatingCarrier = segment?.operatingCarrier
    this.operatingFlightCode = segment?.operatingFlightCode
    this.segmentStatusCode = segment?.segmentStatusCode
    this.segmentStatus  = 'OPEN'
    this.cabinClass = segment?.cabinClass
    this.bookingClass = segment?.bookingClass
    this.farebasis = segment?.farebasis
    this.aircraftType = segment?.aircraftType
    this.flightDuration = segment.flightDuration
    this.layoverDuration = segment?.layoverDuration
    this.sequence = segment?.sequence
    this.onUpgradeList = segment?.onUpgradeList
    this.departureAirportTimeZoneId = segment?.departureAirportTimeZoneId
    this.arrivalAirportTimeZoneId = segment?.arrivalAirportTimeZoneId
    this.hiddenStop = segment?.hiddenStop
    this.arrivalAirportRegion = segment?.arrivalAirportRegion
    this.departureAirportRegion = segment?.departureAirportRegion
    this.remainingSegmentTimeToCheckin = segment?.remainingSegmentTimeToCheckin
    this.windowSegmentStatus = segment?.windowSegmentStatus
    this.departureCountry= segment?.departureCountry
    this.arrivalCountry= segment?.arrivalCountry
  }
}
export class PassengerModelRQ {
  id: string = ''
  passengerNameNumber: string = ''
  passengerInfant: string = ''
  priorityCode: string = ''
  upgradeCode: string = ''
  passengerDetails: PassengerDetailsRQ
  passengerInfo: PassengerInfoRQ
  ticketInfo: TicketInfoRQ

  constructor(passenger:PassengerAWSInt, segmentCode) {
    this.id = passenger?.id;
    this.passengerNameNumber  = passenger?.passengerNameNumber;
    this.passengerInfant =  passenger?.passengerInfant;
    this.passengerDetails = new PassengerDetailsRQ(passenger.passengerDetails);
    this.passengerInfo = new PassengerInfoRQ(passenger.passengerInfo);
    this.ticketInfo= new TicketInfoRQ(passenger.ticketInfo,segmentCode);

  }
}

class  PassengerIdsRQ {
  id: string;
  segmentCode: string;

  constructor(passenger, segmentStatusCode) {
    this.id = passenger.id;
    this.segmentCode = segmentStatusCode;
  }
}

export class PassengerDetailsRQ {
  firstName: string;
  lastName: string;

  constructor(passenger) {
    this.firstName = passenger.firstName;
    this.lastName = passenger.lastName;
  }
}

export class PassengerInfoRQ {
  dateOfBirth: string
  gender: string
  type: string
  countryResidence: string
  redressNumber: RedressNumberRQ
  travelerNumber: TravelerNumberRQ
  ffProgram: string
  ffNumber: string
  ffTierLevel: string
  emails: any[]
  phones: any[]
  passport: PassportRQ
  visa: VisaRQ
  permanentResidentCard: PermanentResidentCardRQ
  emergencyContact: EmergencyContactRQ
  destinationAddress: DestinationAddressRQ
  emailId:string
  constructor(passenger) {
    this.dateOfBirth = passenger.dateOfBirth;
    this.gender = passenger.gender;
    this.type = passenger.type;
    this.countryResidence = passenger.countryResidence
    this.redressNumber = passenger.redressNumber
    this.travelerNumber = passenger.travelerNumber
    this.ffProgram = passenger.ffProgram
    this.ffNumber = passenger.ffNumber
    this.ffTierLevel = passenger.ffTierLevel
    this.emails = passenger.emails
    this.phones = passenger.phones
    this.passport = null
    this.visa = null
    this.emailId = passenger.emailId
    this.permanentResidentCard = null
    this.emergencyContact = null
    this.destinationAddress = null
  }
}

export class RedressNumberRQ {
  constructor(passenger) {
    Object.assign(this, passenger)
    }
}

export class TravelerNumberRQ {
  constructor(passenger) {
    Object.assign(this, passenger)
  }
}

export class PassportRQ {
  public expirationDate: string;
  public issueCountry: string;
  public nationality: string;
  public documentNumber: string;
  public passportScanned: boolean;

  constructor(passport) {
    Object.assign(this, passport)
  }
}

export class VisaRQ {
  constructor(passenger) {
    Object.assign(this, passenger)
  }
}

export class PermanentResidentCardRQ {
  constructor(passenger) {
    Object.assign(this, passenger)
  }
}

export class EmergencyContactRQ {
  constructor(passenger) {
    Object.assign(this, passenger)
  }
}

export class DestinationAddressRQ {
  constructor(passenger) {
    Object.assign(this, passenger)
  }
}

export class TicketInfoRQ {
  eticket: string = null;
  coupons: CouponRQ[] = null

  constructor(ticketInfo,segmentCode) {
    if (ticketInfo) {
      this.eticket = ticketInfo.eticket;
      this.coupons = ticketInfo.coupons.filter(coupon=> coupon.segmentCode == segmentCode)
    }
  }
}

export class CouponRQ {
  couponNumber: number
  couponStatus: string
  segmentCode: string

  constructor(coupons ) {
    if (coupons) {
      this.couponNumber = coupons?.couponNumber || 1;
      this.couponStatus = coupons?.couponStatus ||  "OK";
      this.segmentCode = coupons?.segmentCode ;
    }


  }
}


